import React from 'react';
import { cn } from '@/lib/utils';
import { CollapsibleHashtags } from './CollapsibleHashtags';
import { CollapsibleCreators } from './CollapsibleCreators';
import { CollapsibleBrands } from './CollapsibleBrands';
import tiktokLogo from '@/assets/images/report/tiktok-trends/logo.svg';
import smile from '@/assets/images/report/tiktok-trends/smile.svg';
import {
  getFilledBrands,
  getFilledCreators,
  getFilledHashtagCategories,
} from './utils/hasContent';

export interface TiktokTrendsViewProps {
  hashtagCategories?: unknown[];
  creators?: unknown[];
  brands?: unknown[];
}

export const TiktokTrendsView: React.FC<TiktokTrendsViewProps> = ({
  hashtagCategories,
  creators,
  brands,
}) => {
  const filledHashtagCategories = getFilledHashtagCategories(hashtagCategories);
  const filledCreators = getFilledCreators(creators);
  const filledBrands = getFilledBrands(brands);
  const sections = [
    filledHashtagCategories.length > 0 ? (
      <CollapsibleHashtags key="hashtags" categories={filledHashtagCategories} />
    ) : null,
    filledCreators.length > 0 ? (
      <CollapsibleCreators key="creators" creators={filledCreators} />
    ) : null,
    filledBrands.length > 0 ? (
      <CollapsibleBrands key="brands" brands={filledBrands} />
    ) : null,
  ].filter(Boolean);
  const visibleCount = sections.length;

  return (
    <div className="w-full">
      <header className="w-full bg-[#F2F2F2] overflow-hidden font-['Times_New_Roman']">
        <div className="w-full flex container justify-center">
          <div className="w-full flex justify-center min-h-[140px]">
            <div className="flex-1 py-4 px-4 flex flex-col items-center justify-center">
              <div className="flex items-center gap-4">
                <img src={tiktokLogo} alt="" className="h-36 w-36 shrink-0 object-contain" />
                <h2 className="text-black text-[73px] leading-[73px] tracking-tight">
                  <span className="block">trends</span>
                  <span className="block">TikTok</span>
                </h2>
              </div>
              <div className="flex items-end gap-4 mt-2">
                <div
                  className="text-black text-[73px] leading-[73px] max-h-[200px] [writing-mode:vertical-rl] [text-orientation:mixed] rotate-180"
                  aria-hidden
                >
                  trends TikTok
                </div>
                <div className="p-3 shrink-0">
                  <img
                    src={smile}
                    alt=""
                    className="w-[200px] h-[200px] object-contain rotate-180"
                    aria-hidden
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {visibleCount > 0 && (
        <div className="container">
          <div
            className={cn(
              'grid grid-cols-1 md:items-start gap-0',
              visibleCount === 1 && 'md:grid-cols-1',
              visibleCount === 2 && 'md:grid-cols-2',
              visibleCount >= 3 && 'md:grid-cols-3'
            )}
          >
            {sections}
          </div>
        </div>
      )}
    </div>
  );
};
